export default __webpack_public_path__ + "static/media/bar-chart.06f23a9b.svg";